import {compact} from 'lodash';

const filterNonDisplayableListings = ({previouslyViewedSearch: {listings}}) =>
    listings.filter((listing) => {
        const {
            headlinePhoto,
            bedrooms,
            sleeps,
            averageRating,
            reviewCount,
            priceSummary
        } = listing;
        const hasImageUrl = headlinePhoto && headlinePhoto.uri;
        const hasBedroomsOrSleeps = bedrooms || sleeps;
        const hasReviews = averageRating && reviewCount;

        // carousel card display conditions:
        // 1. image is present
        // 2. two of three content items are present:
        //    a) bedrooms or sleeps count
        //    b) avarage rating and reviews count
        //    c) price summary
        return (
            hasImageUrl &&
            compact([hasBedroomsOrSleeps, hasReviews, priceSummary]).length > 1
        );
    });

export default filterNonDisplayableListings;
